import React, { useState, useCallback } from 'react';
import { Modal, ModalBody, ModalHeader, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { getOpenDocumentModelUrl } from '@/services/documents';
import { FileData } from '@ygtechnologies/rubus-frontend-utilities';
import { useOnWindowResize } from '@/utils/hooks';
import { Trans } from '@lingui/react/macro';
import { LazyBimViewer } from './LazyBimViewer';

interface ModelViewerModalProps {
    isOpen: boolean;
    versionId: number;
    toggle: () => void;
}

const ModelViewerModal: React.FC<ModelViewerModalProps> = ({ isOpen, versionId, toggle }) => {
    const [width, setWidth] = useState(window.innerWidth * 0.9);
    const [height, setHeight] = useState(window.innerHeight * 0.85);

    const calculateModalWidth = useCallback(() => {
        setWidth(window.innerWidth * 0.9);
        setHeight(window.innerHeight * 0.85);
    }, []);

    useOnWindowResize(() => {
        calculateModalWidth();
    });
    const [file, setFile] = useState<FileData | null>(null);
    const loadFile = async () => {
        const f = await FileData.download(getOpenDocumentModelUrl(versionId));
        setFile(f);
    };
    const onClose = () => {
        setFile(null);
    };
    return (
        <Modal onClose={onClose} style={{ width }} toggle={toggle} onOpen={loadFile} isOpen={isOpen}>
            <ModalHeader>{file ? file.fileName : <Trans>Loading</Trans>}</ModalHeader>
            <ModalBody className="flex center">
                {file ? <LazyBimViewer height={height - 40} width={width - 40} file={file} /> : <LoadingIndicator />}
            </ModalBody>
        </Modal>
    );
};

export default ModelViewerModal;
